module.exports = __webpack_public_path__ + "4a71f08f961ef748c6e2bd130be21001.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/BinauralNoiseManagementOFF.mp4
// module id = 390
// module chunks = 0